import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const CONTENT_GAP = {
  [HD]: 16,
  [FULL_HD]: 24,
};
